let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("9cxnP")).then(() => parcelRequire('3J1Lm'));